export default
{"Tuvalu":"TV",
"Albania":"AL",
"Algeria":"DZ",
"Andorra":"AD",
"Angola":"AO",
"Antigua and Barbuda":"AG",
"Argentina":"AR",
"Armenia":"AM",
"Australia":"AU",
"Austria":"AT",
"Azerbaijan":"AZ",
"Bahamas, The":"BS",
"Bahrain":"BH",
"Bangladesh":"BD",
"Barbados":"BB",
"Belarus":"BY",
"Belgium":"BE",
"Belize":"BZ",
"Bhutan":"BT",
"Bolivia":"BO",
"Bosnia and Herzegovina":"BA",
"Botswana":"BW",
"Brazil":"BR",
"Brunei":"BN",
"Burkina Faso":"BF",
"Burundi":"BI",
"Cambodia":"KH",
"Cameroon":"CM",
"Canada":"CA",
"Cabo Verde":"CV",
"Central African Republic":"CF",
"Chad":"TD",
"Chile":"CL",
"China":"CN",
"Colombia":"CO",
"Comoros":"KM",
"Congo, Dem. Rep":"CD",
"Congo, Rep.":"CG",
"Costa Rica":"CR",
"Côte d'Ivoire":"CI",
"Croatia":"HR",
"Cuba":"CU",
"Cyprus":"CY",
"Czech Republic":"CZ",
"Denmark":"DK",
"Djibouti":"DJ",
"Dominican Republic":"DO",
"Ecuador":"EC",
"El Salvador":"SV",
"Equatorial Guinea":"GQ",
"Eritrea":"ER",
"Estonia":"EE",
"Ethiopia":"ET",
"Fiji":"FJ",
"Finland":"FI",
"France":"FR",
"Gabon":"GA",
"Gambia":"GM",
"Georgia":"GE",
"Germany":"DE",
"Ghana":"GH",
"Greece":"GR",
"Grenada":"GD",
"Guatemala":"GT",
"Guinea":"GN",
"Guinea-Bisau":"GW",
"Guyana":"GY",
"Haiti":"HT",
"Hungary":"HU",
"Iceland":"IS",
"India":"IN",
"Indonesia":"ID",
"Iraq":"IQ",
"Ireland":"IE",
"Italy":"IT",
"Jamaica":"JM",
"Japan":"JP",
"Jordan":"JO",
"Kazakhstan":"KZ",
"Kenya":"KE",
"Kiribati":"KI",
"North Korea":"KP",
"South Korea":"KR",
"Kuwait":"KW",
"Kyrgyz Republic":"KG",
"Laos":"LA",
"Latvia":"LV",
"Lebanon":"LB",
"Lesotho":"LS",
"Liberia":"LR",
"Libya":"LY",
"Liechtenstein":"LI",
"Lithuania":"LT",
"Luxembourg":"LU",
"Macedonia":"MK",
"Madagascar":"MG",
"Malawi":"MW",
"Maldives":"MV",
"Mali":"ML",
"Malta":"MT",
"Marshall Islands":"MH",
"Mauritania":"MR",
"Mauritius":"MU",
"Mexico":"MX",
"Micronesia":"FM",
"Moldova":"MD",
"Monaco":"MC",
"Mongolia":"MN",
"Montenegro":"ME",
"Morocco":"MA",
"Mozambique":"MZ",
"Myanmar":"MM",
"Namibia":"NA",
"Nauru":"NR",
"Nepal":"NP",
"New Zealand":"NZ",
"Nicaragua":"NI",
"Niger":"NE",
"Nigeria":"NG",
"Norway":"NO",
"Oman":"OM",
"Palau":"PW",
"Panama":"PA",
"Papua New Guinea":"PG",
"Paraguay":"PY",
"Peru":"PE",
"Philippines":"PH",
"Poland":"PL",
"Portugal":"PT",
"Qatar":"QA",
"Romania":"RO",
"Russia":"RU",
"Rwanda":"RW",
"St. Lucia":"LC",
"St. Vincent and the Grenadines":"VC",
"Samoa":"WS",
"San Marino":"SM",
"Sao Tome and Principe":"ST",
"Saudi Arabia":"SA",
"Senegal":"SN",
"Serbia":"RS",
"Seychelles":"SC",
"Sierra Leone":"SL",
"Singapore":"SG",
"Slovakia":"SK",
"Solomon Islands":"SB",
"Somalia":"SO",
"Spain":"ES",
"Sri Lanka":"LK",
"Sudan":"SD",
"Suriname":"SR",
"Swaziland":"SZ",
"Sweden":"SE",
"Switzerland":"CH",
"Syria":"SY",
"Tajikistan":"TJ",
"Tanzania":"TZ",
"Thailand":"TH",
"Timor-Leste":"TL",
"Togo":"TG",
"Tonga":"TO",
"Trinidad and Tobago":"TT",
"Tunisia":"TN",
"Turkey":"TR",
"Turkmenistan":"TM",
"Uganda":"UG",
"Ukraine":"UA",
"United Arab Emirates":"AE",
"United Kingdom":"GB",
"Heard Island and McDonald Islands":"HM",
"Uruguay":"UY",
"Uzbekistan":"UZ",
"Vanuatu":"VU",
"Vatican City":"VA",
"Venezuela":"VE",
"Vietnam":"VN",
"Yemen":"YE",
"Zimbabwe":"ZW",
"Abkhazia":"GX",
"Taiwan":"TW",
"Christmas Island":"CX",
"Cocos (Keeling) Islands":"CC",
"Norfolk Island":"NF",
"New Caledonia":"NC",
"French Polynesia":"PF",
"Mayotte":"YT",
"Saint Pierre and Miquelon":"PM",
"Wallis and Futuna":"WF",
"French Southern and Antarctic Lands":"TF",
"Bouvet Island":"BV",
"Cook Islands":"CK",
"Niue":"NU",
"Tokelau":"TK",
"Isle of Man":"IM",
"Jersey":"JE",
"Anguilla":"AI",
"Bermuda":"BM",
"British Indian Ocean Territory":"IO",
"British Virgin Islands":"VG",
"Cayman Islands":"KY",
"Gibraltar":"GI",
"Montserrat":"MS",
"Pitcairn Islands":"PN",
"Saint Helena":"SH",
"South Georgia & South Sandwich Islands":"GS",
"Turks and Caicos Islands":"TC",
"Puerto Rico":"PR",
"American Samoa":"AS",
"Guam":"GU",
"U.S. Virgin Islands":"VI",
"Hong Kong":"HK",
"Macau":"MO",
"Faroe Islands":"FO",
"Greenland":"GL",
"French Guiana":"GF",
"Guadeloupe":"GP",
"Martinique":"MQ",
"Reunion":"RE",
"Afghanistan":"AF",
"Benin":"BJ",
"Bulgaria":"BG",
"Dominica":"DM",
"Egypt":"EG",
"Honduras":"HN",
"Iran":"IR",
"Israel":"IL",
"Malaysia":"MY",
"Netherlands":"NL",
"Pakistan":"PK",
"Saint Kitts and Nevis":"KN",
"Slovenia":"SI",
"South Africa":"ZA",
"United States":"US",
"Zambia":"ZM",
"Aruba":"AW",
"Netherlands Antilles":"AN",
"Svalbard":"SJ",
"Ascension":"AC",
"Tristan da Cunha":"TA",
"Kosovo":"XK",
"South Sudan":"SS",
"West Bank and Gaza":"PS",
"Guernsey":"GG",
"Falkland Islands (Islas Malvinas)":"FK",
"Aland":"AX"}



// WEBPACK FOOTER //
// ./src/assets/countries.js